/**
 * The country page's two non-plan states: no plan / failed load, and the
 * loading skeleton. Kept apart so the page stays within its size budget.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Link } from 'react-router-dom';

import { Button, Card } from '@/components/ui';
import { AUTOMATION_PATH } from '@/features/drop-generator/utils/automation-paths';

interface ErrorProps {
  countryName: string;
  /** false = the country has no plan at all; undefined = unknown yet. */
  known: boolean | undefined;
  creating: boolean;
  onCreate: () => void;
}

export const PlanErrorCard: FC<ErrorProps> = ({ countryName, known, creating, onCreate }) => (
  <Card className="m-1 flex flex-col items-start gap-3 p-6">
    <p className="text-sm font-medium">
      {known === false ? `${countryName} has no Automation plan yet.` : 'This plan could not be loaded.'}
    </p>
    <div className="flex gap-2">
      {known === false ? (
        <Button size="sm" loading={creating} onClick={onCreate}>
          Create the plan
        </Button>
      ) : null}
      <Button variant="ghost" size="sm" asChild>
        <Link to={AUTOMATION_PATH}>← Back to countries</Link>
      </Button>
    </div>
  </Card>
);

export const PlanSkeleton: FC = () => (
  <div className="flex flex-col gap-3 p-1">
    {[0, 1, 2].map((i) => (
      <div key={i} className="h-24 animate-pulse rounded-xl bg-muted/60" />
    ))}
  </div>
);
